import { isYoutubeUrl } from "../../../common/youtube_tools.es6";

/**
 * HELPER FUNCTIONS FOR THE CLIPBOARD
 *
 */

/**
 * Async function for retrieving an image from the clipboard
 * @param pasteEvent Paste event captured
 * @param callback Callback function for when finishing parsing the image
 * @param imageFormat Resulting image format
 * @returns {boolean} True if there is images in the clipboard. False otherwise
 */
export function retrieveImageFromClipboardAsBase64(
  pasteEvent,
  uploadFunction,
  callback,
  imageFormat
) {
  // TODO link with VISH
  if (pasteEvent.clipboardData === false) {
    if (typeof callback === "function") {
      callback(undefined);
    }
  }
  let items = pasteEvent.clipboardData.items;
  if (items === undefined) {
    if (typeof callback === "function") {
      callback(undefined);
    }
  }
  let noImage = false;
  for (let i = 0; i < items.length; i++) {
    // Skip content if not image
    if (items[i].type.indexOf("image") !== -1) {
      // Retrieve image on clipboard as blob
      let blob = items[i].getAsFile();
      // Create an abstract canvas and get context
      let mycanvas = document.createElement("canvas");
      let ctx = mycanvas.getContext("2d");
      // Create an image
      let img = new Image();
      // Once the image loads, render the img on the canvas

      if (typeof uploadFunction === "function") {
        uploadFunction(blob, [], (url) => {
          if (typeof callback === "function") {
            callback(url);
          }
        });
      }
      /* img.onload = function() {
                // Update dimensions of the canvas with the dimensions of the image
                mycanvas.width = this.width;
                mycanvas.height = this.height;

                // Draw the image
                ctx.drawImage(img, 0, 0);
                let image = mycanvas.toDataURL(
                  (imageFormat || "image/png")
                );
                // Execute callback with the base64 URI of the image
              if(typeof(uploadFunction) === "function") {
                uploadFunction(blob,[], (url=>{
                  if (typeof(callback) === "function") {
                    callback(url);
                  }})
                );
              }
            };
            // Crossbrowser support for URL
            let URLObj = window.URL || window.webkitURL;
            // Creates a DOMString containing a URL representing the object given in the parameter
            // namely the original Blob
            img.src = URLObj.createObjectURL(blob);*/
    } else if (i === items.length - 1 && noImage === false) {
      noImage = true;
    }
  }
  return noImage;
}

/**
 * Retrives image from clipboard as blob. Not used as for now but it may be needed in the future
 * @param pasteEvent Paste event captured
 * @param callback Callback function for when finishing parsing the image
 */
export function retrieveImageFromClipboardAsBlob(pasteEvent, callback) {
  if (pasteEvent.clipboardData === false) {
    if (typeof callback === "function") {
      callback(undefined);
    }
  }

  let items = pasteEvent.clipboardData.items;

  if (items === undefined) {
    if (typeof callback === "function") {
      callback(undefined);
    }
  }

  for (let i = 0; i < items.length; i++) {
    // Skip content if not image
    if (items[i].type.indexOf("image") !== -1) {
      // Retrieve image on clipboard as blob
      let blob = items[i].getAsFile();

      if (typeof callback === "function") {
        callback(blob);
      }
    }
  }
}

/**
 * Generates a random percentage between the given numbers
 * @param min Min percentage
 * @param max Max percentage
 * @returns {string} Generated value. Ex: 50.02%
 */
export function randomPositionGenerator(min, max) {
  return (Math.random() * (max - min) + min).toFixed(2) + "%";
}

/**
 * Adapt the text from the clipboard to HTML that the CKEditor recognizes
 * @param data Clipboard data in HTML or plain text
 * @returns {string} Resulting CKEditor content
 */

function replacerPt(str, p1) {
  return "" + Math.round(((p1 * 2) / 21) * 1000) / 1000 + "em";
}
function replacerPx(str, p1, p2, offset, s) {
  return "" + Math.round((p1 / 14) * 1000) / 1000 + "em";
}

export function getCKEDITORAdaptedContent(data) {
  // Check if CKEDITOR is available
  if (typeof CKEDITOR === "undefined" || !CKEDITOR.htmlParser) {
    // Return the original data if CKEDITOR is not available
    return data;
  }

  // Remove HTML comments before parsing
  data = data.replace(/<!--[\s\S]*?-->/g, "");

  // Parse HTML version
  // let filter = new CKEDITOR.filter( 'p b' ),
  // Parse the HTML string to pseudo-DOM structure.
  let fragment = CKEDITOR.htmlParser.fragment.fromHtml(data);
  let writer = new CKEDITOR.htmlParser.basicWriter();

  fragment.writeHtml(writer);
  let parsedHTML = writer.getHtml();

  // parsedHTML = parsedHTML.replace(/([1-9]\d*(\.\d+)?)px/gim, replacerPx)
  // parsedHTML = parsedHTML.replace(/([1-9]\d*(\.\d+)?)pt/gim, replacerPt)

  parsedHTML = parsedHTML.replace(/style=\"(.*;)*\"/gim, function (str, p1, p2) {
    let styled = p1.replace(/([0-9]\d*(\.\d+)?)pt/gim, replacerPt);
    styled = styled.replace(/([0-9]\d*(\.\d+)?)px/gim, replacerPx);
    return 'style="' + styled + '"';
  });
  parsedHTML = parsedHTML.replace(/<style>(.*;)*<\/style>/gim, function (str, p1, p2) {
    let styled = p1.replace(/([0-9]\d*(\.\d+)?)pt/gim, replacerPt);
    styled = styled.replace(/([0-9]\d*(\.\d+)?)px/gim, replacerPx);
    return "<style>" + styled + "</style>";
  });
  return encodeURI(parsedHTML);
  /* return encodeURI(
     decodeURI(
     CKEDITOR.tools.htmlEncode(data)
     )
     );
     */
  // Plain text version
  // return (event.clipboardData.getData("text/plain"));
}

export function isURL(str) {
  if (!str) {
    return false;
  }
  let pattern = new RegExp(
    "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|" + // domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$",
    "i"
  ); // fragment locator
  return pattern.test(str);
}

// ── Scene clipboard helpers ───────────────────────────────────────────────────

/**
 * Walk a box's sortableContainers recursively and collect all nested box ids.
 * Returns a flat array of child box ids.
 */
function collectNestedBoxIds(box) {
  const ids = [];
  if (!box || !box.sortableContainers) return ids;
  for (const sc in box.sortableContainers) {
    const children = box.sortableContainers[sc].children || [];
    for (const childId of children) {
      ids.push(childId);
    }
  }
  return ids;
}

/**
 * Collect everything that belongs to a scene into a plain-data snapshot.
 *
 * @param {string} sceneId
 * @param {{ navItemsById, boxesById, pluginToolbarsById, marksById,
 *           viewToolbarsById, exercises, animationsById, soundList,
 *           containedViewsById }} state
 * @returns {{ navItem, boxes, toolbars, marks, viewToolbar, exercises,
 *             animations, soundList, containedViews }}
 */
export function collectScene(sceneId, state) {
  const {
    navItemsById,
    boxesById,
    pluginToolbarsById,
    marksById,
    viewToolbarsById,
    exercises,
    animationsById,
    soundList,
    containedViewsById,
  } = state;

  const navItem = navItemsById[sceneId];

  // Collect top-level box ids from the scene, then recurse into sortable containers
  const topBoxIds = navItem.boxes || [];
  const allBoxIds = [];

  function addBox(id) {
    if (allBoxIds.includes(id)) return;
    allBoxIds.push(id);
    const box = boxesById[id];
    if (!box) return;
    for (const childId of collectNestedBoxIds(box)) {
      addBox(childId);
    }
  }

  for (const id of topBoxIds) {
    addBox(id);
  }

  const boxes = {};
  const toolbars = {};
  const animations = {};
  const boxIdSet = new Set(allBoxIds);

  for (const id of allBoxIds) {
    if (boxesById[id]) boxes[id] = boxesById[id];
    if (pluginToolbarsById[id]) toolbars[id] = pluginToolbarsById[id];
    if (animationsById && animationsById[id]) animations[id] = animationsById[id];
  }

  // Marks whose origin is one of the collected boxes
  const marks = {};
  for (const markId in marksById) {
    const mark = marksById[markId];
    if (boxIdSet.has(mark.origin)) {
      marks[markId] = mark;
    }
  }

  // Contained views referenced by collected marks
  const containedViews = {};
  for (const markId in marks) {
    const mark = marks[markId];
    const cvId = mark.connection;
    if (cvId && containedViewsById && containedViewsById[cvId]) {
      const cvNavItem = containedViewsById[cvId];
      const cvBoxIds = cvNavItem.boxes || [];
      const cvBoxes = {};
      const cvToolbars = {};
      for (const id of cvBoxIds) {
        if (boxesById[id]) cvBoxes[id] = boxesById[id];
        if (pluginToolbarsById[id]) cvToolbars[id] = pluginToolbarsById[id];
      }
      containedViews[cvId] = { navItem: cvNavItem, boxes: cvBoxes, toolbars: cvToolbars };
    }
  }

  return {
    navItem,
    boxes,
    toolbars,
    marks,
    viewToolbar: viewToolbarsById ? viewToolbarsById[sceneId] : undefined,
    exercises: exercises ? exercises[sceneId] : undefined,
    animations,
    soundList: (soundList && soundList[sceneId]) || [],
    containedViews,
  };
}

/**
 * Classify the assets (media URLs) referenced by a collected scene.
 *
 * @param {{ toolbars, soundList }} scene  (as returned by collectScene)
 * @returns {{ assets: {url,type,fileId?}[], assetCounts: {images,videos,sounds,narrations} }}
 */
export function classifyAssets(scene) {
  const { toolbars, soundList } = scene;
  const seen = new Set();
  const assets = [];
  const assetCounts = { images: 0, videos: 0, sounds: 0, narrations: 0 };

  function isHttpUrl(url) {
    return typeof url === "string" && /^https?:\/\//i.test(url);
  }

  function addAsset(url, type, fileId) {
    if (!isHttpUrl(url) || !isCopyableAsset(url)) return;
    if (seen.has(url)) return;
    seen.add(url);
    const entry = { url, type };
    if (fileId != null) entry.fileId = fileId;
    assets.push(entry);
    if (type === "image") assetCounts.images++;
    else if (type === "video") assetCounts.videos++;
    else if (type === "sound") assetCounts.sounds++;
    else if (type === "narration") assetCounts.narrations++;
  }

  // Toolbars: HotspotImages → image, EnrichedPlayer → video
  for (const id in toolbars) {
    const tb = toolbars[id];
    const url = tb && tb.state && tb.state.url;
    if (!url) continue;
    if (tb.pluginId === "HotspotImages") {
      addAsset(url, "image");
    } else if (tb.pluginId === "EnrichedPlayer") {
      addAsset(url, "video");
    }
  }

  // SoundList
  const sounds = soundList || [];
  for (const item of sounds) {
    const url = item.file;
    const type = item.usageType === "scene-audio" ? "narration" : "sound";
    addAsset(url, type);
  }

  return { assets, assetCounts };
}

/**
 * Re-key all ids in a collected scene and rewrite asset URLs via urlMap.
 *
 * @param {object} scene   Result of collectScene
 * @param {object} urlMap  { [oldUrl]: newUrl } — keys absent → url unchanged
 * @param {function} idFactory  () => string — called once per new id
 * @returns scene shape + newSceneId
 */
export function rekeyScene(scene, urlMap, idFactory) {
  const {
    navItem,
    boxes,
    toolbars,
    marks,
    viewToolbar,
    exercises,
    animations,
    soundList,
    containedViews,
  } = scene;

  // ── Pass 1: build idMap ─────────────────────────────────────────────────
  const idMap = {};

  function newId(oldId) {
    if (!idMap[oldId]) idMap[oldId] = idFactory(oldId);
    return idMap[oldId];
  }

  // Scene id
  const newSceneId = newId(navItem.id);

  // Top-level box ids
  for (const id in boxes) {
    newId(id);
    // sortableContainer children
    const box = boxes[id];
    if (box.sortableContainers) {
      for (const sc in box.sortableContainers) {
        const children = box.sortableContainers[sc].children || [];
        for (const childId of children) {
          newId(childId);
        }
      }
    }
  }

  // Mark ids
  for (const markId in marks) {
    newId(markId);
  }

  // Contained view ids
  for (const cvId in containedViews) {
    newId(cvId);
    const cv = containedViews[cvId];
    for (const bid in cv.boxes) {
      newId(bid);
    }
  }

  // ── Pass 2: deep-clone and rewrite ──────────────────────────────────────
  const clone = JSON.parse(JSON.stringify(scene));

  function remapId(id) {
    return idMap[id] !== undefined ? idMap[id] : id;
  }

  function rewriteUrl(url) {
    if (typeof url === "string" && urlMap[url] !== undefined) return urlMap[url];
    return url;
  }

  // navItem
  clone.navItem.id = newSceneId;
  clone.navItem.boxes = (clone.navItem.boxes || []).map(remapId);

  // boxes map: rekey map entries and update box internals
  const newBoxes = {};
  for (const oldId in clone.boxes) {
    const box = clone.boxes[oldId];
    box.id = remapId(oldId);
    box.parent = remapId(box.parent);
    box.container = remapId(box.container);
    if (box.sortableContainers) {
      for (const sc in box.sortableContainers) {
        const children = box.sortableContainers[sc].children || [];
        box.sortableContainers[sc].children = children.map(remapId);
      }
    }
    newBoxes[box.id] = box;
  }
  clone.boxes = newBoxes;

  // toolbars map: rekey map entries, update id, rewrite url
  const newToolbars = {};
  for (const oldId in clone.toolbars) {
    const tb = clone.toolbars[oldId];
    tb.id = remapId(oldId);
    if (tb.state && tb.state.url != null) {
      tb.state.url = rewriteUrl(tb.state.url);
    }
    newToolbars[tb.id] = tb;
  }
  clone.toolbars = newToolbars;

  // animations map
  const newAnimations = {};
  for (const oldId in clone.animations) {
    newAnimations[remapId(oldId)] = clone.animations[oldId];
  }
  clone.animations = newAnimations;

  // marks map
  const newMarks = {};
  for (const oldMarkId in clone.marks) {
    const mark = clone.marks[oldMarkId];
    mark.id = remapId(oldMarkId);
    mark.origin = remapId(mark.origin);
    if (mark.connection && idMap[mark.connection] !== undefined) {
      mark.connection = idMap[mark.connection];
    }
    newMarks[mark.id] = mark;
  }
  clone.marks = newMarks;

  // viewToolbar id
  if (clone.viewToolbar) {
    clone.viewToolbar.id = newSceneId;
  }

  // soundList: rewrite file urls
  if (Array.isArray(clone.soundList)) {
    for (const item of clone.soundList) {
      if (item.file != null) item.file = rewriteUrl(item.file);
    }
  }

  // containedViews
  const newContainedViews = {};
  for (const oldCvId in clone.containedViews) {
    const cv = clone.containedViews[oldCvId];
    const newCvId = remapId(oldCvId);
    cv.navItem.id = newCvId;

    const newCvBoxes = {};
    for (const oldBid in cv.boxes) {
      const b = cv.boxes[oldBid];
      b.id = remapId(oldBid);
      newCvBoxes[b.id] = b;
    }
    cv.boxes = newCvBoxes;

    const newCvToolbars = {};
    for (const oldBid in cv.toolbars) {
      const tb = cv.toolbars[oldBid];
      tb.id = remapId(oldBid);
      if (tb.state && tb.state.url != null) tb.state.url = rewriteUrl(tb.state.url);
      newCvToolbars[tb.id] = tb;
    }
    cv.toolbars = newCvToolbars;

    newContainedViews[newCvId] = cv;
  }
  clone.containedViews = newContainedViews;

  // exercises: the page-level entry ({ id, exercises: { [boxId]: {...} }, … }).
  // Its inner map is keyed by box id, so it MUST be re-keyed to the new box ids
  // or the pasted question box has no exercises entry — the assessment plugins
  // read props.exercises.correctAnswer unguarded and the editor render crashes.
  if (clone.exercises && typeof clone.exercises === "object") {
    if (clone.exercises.id !== undefined) clone.exercises.id = newSceneId;
    if (clone.exercises.exercises && typeof clone.exercises.exercises === "object") {
      const newExMap = {};
      for (const oldBid in clone.exercises.exercises) {
        const ex = clone.exercises.exercises[oldBid];
        const newBid = remapId(oldBid);
        if (ex && ex.id !== undefined) ex.id = newBid;
        newExMap[newBid] = ex;
      }
      clone.exercises.exercises = newExMap;
    }
  }

  clone.newSceneId = newSceneId;
  return clone;
}

// ── Element (single/multi box) cross-training paste ─────────────────────────

// Any http(s) URL inside the serialized box (toolbar state, GuideMultiInput
// items, HTML src="…", …). The server skips URLs it can't scope to the source
// training, so over-collecting is safe.
const URL_RE = /https?:\/\/[^\s"'<>\\)]+/g;

/** True when a copied element came from a different training than `currentTrainingId`. */
export function needsAssetCopy(data, currentTrainingId) {
  const src = data && data.source;
  return !!(src && src.trainingId && src.trainingId !== currentTrainingId);
}

function withoutSource(data) {
  const { source, ...rest } = data;
  return rest;
}

// A YouTube video is a link the player embeds, not a file: copying it into the
// training stores the YouTube web page under the video id.
function isCopyableAsset(url) {
  return !isYoutubeUrl(url);
}

/** Unique http(s) asset URLs of a copied element, typed for copy-assets. */
export function collectBoxAssets(data) {
  const urls = new Set(JSON.stringify(withoutSource(data)).match(URL_RE) || []);
  return [...urls].filter(isCopyableAsset).map((url) => {
    const path = url.split(/[?#]/)[0].toLowerCase();
    const type = /\.(mp4|webm|mov|m4v)$/.test(path)
      ? "video"
      : /\.(mp3|wav|ogg|m4a|aac)$/.test(path)
        ? "sound"
        : "image";
    return { url, type };
  });
}

/** Rewrites asset URLs via urlMap and drops `source` so the paste is treated as local. */
export function applyUrlMap(data, urlMap) {
  const json = JSON.stringify(withoutSource(data)).replace(URL_RE, (u) =>
    urlMap && urlMap[u] !== undefined ? urlMap[u] : u
  );
  return JSON.parse(json);
}

// ─────────────────────────────────────────────────────────────────────────────

export function copyText(text) {
  // Create the textarea input to hold our text.
  try {
    const element = document.createElement("textarea");
    element.value = text instanceof Object ? JSON.stringify(text) : text;
    // Add it to the document so that it can be focused.
    document.body.appendChild(element);
    // Focus on the element so that it can be copied.
    element.focus();
    element.setSelectionRange(0, element.value.length);
    // Execute the copy command.
    document.execCommand("copy");
    // Remove the element to keep the document clear.
    document.body.removeChild(element);
    return true;
  } catch (e) {
    return false;
  }
}
